<template>
  <div>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head text-center">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body px-25 pt-30 pb-40">
        <div class="media">
          <figure class="media-left">
            <p class="img-resize img-resize--smallest">
              <img v-if="itemImageShow" :src="item.image">
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <div class="content-item word-break-all">
                <span v-show="itemSubtitleShow">{{ item.subtitle }}</span>
                <br>
                <router-link v-if="itemUrlShow" :to="item.route" target='_blank'><strong>{{ item.title }}</strong></router-link>
                <strong v-else-if="itemTitleShow" class="c-primary">{{ item.title }}</strong>
                <br>
                <span v-show="itemDateShow" class="info info-date">{{ `発送日  ： ${item.date}` }}</span>
              </div>
              <div v-show="itemDescriptionShow" class="description mt-10">{{ item.description }}</div>
            </div>
          </div>
        </div>
        <div class="text-center mt-40">
          <div class="mb-15">
            <button :class="{'confirmed is-disable': confirmed}" class="button is-outlined" type="button" @click="actionOne()">
              <b-icon icon="check"></b-icon>
              <span>商品が到着しました</span>
            </button>
          </div>
          <button :class="confirmed ? 'is-primary' : 'is-grey3 is-disable'" class="button" @click="actionTwo()">レビューを書く</button>
        </div>
      </section>
    </div>
  </div>
</template>
<style lang="scss" src="./confirm-popup.scss" scoped>
</style>
<script>
export default {
  name: 'ConfirmPopup',
  props: {
    title: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({
        route: null,
        title: '',
        subtitle: '',
        image: '',
        date: '',
        description: ''
      })
    },
    close: {
      type: Function,
      default: () => this.$parent.close()
    },
    confirm: {
      type: Boolean,
      default: () => false
    },
    actionOne: {
      type: Function,
      default: () => null
    },
    actionTwo: {
      type: Function,
      default: () => null
    }
  },
  data() {
    return {
      confirmed: false
    };
  },
  computed: {
    itemUrlShow: function() {
      return this.item && this.item.route;
    },
    itemTitleShow: function() {
      return this.item && this.item.title && this.item.title.length > 0;
    },
    itemSubtitleShow: function() {
      return this.item && this.item.subtitle && this.item.subtitle.length > 0;
    },
    itemImageShow: function() {
      return this.item && this.item.subtitle && this.item.subtitle.length > 0;
    },
    itemDateShow: function() {
      return this.item && this.item.image && this.item.image.length > 0;
    },
    itemDescriptionShow: function() {
      return this.item && this.item.description && this.item.description.length > 0;
    }
  },
  watch: {
    confirm: function(value) {
      this.confirmed = value;
    }
  }
};
</script>
